<template>
  <b-navbar
    fixed="top"
    class="pt-4 px-3"
    data-aos="fade-down"
    data-aos-delay="1200"
  >
    <b-container>
      <b-col cols="12" md="6" class="px-0 d-none d-md-block">
        <a class="logo" href="#" @click="moveTo('home')"> </a>
      </b-col>
      <b-col cols="12" md="6" class="px-0 d-md-none" align="center">
        <a class="logo" href="#" @click="moveTo('home')"> </a>
      </b-col>
      <b-col cols="12" md="6" class="px-0 d-none d-md-block">
        <b-navbar-nav align="right">
          <b-nav-item @click="moveTo('home')" href="#" class="px-4"
            >Home</b-nav-item
          >
          <b-nav-item @click="moveTo('about')" href="#" class="px-4"
            >About</b-nav-item
          >
          <b-nav-item @click="moveTo('features')" href="#" class="pl-4"
            >Features</b-nav-item
          >
          <b-nav-item @click="moveTo('contact')" href="#" class="pl-4"
            >Contact Us</b-nav-item
          >
        </b-navbar-nav>
      </b-col>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    moveTo(dest) {
      return this.$parent.$refs.fullpage.api.moveTo(dest)
    }
  }
}
</script>

<style lang="scss" scoped>
/* Actions buttons
 * --------------------------------------- */
nav {
  background-color: #fff;
}
.actions {
  position: absolute;
  top: 20px;
  margin: 0 auto;
  z-index: 99;
  right: 0;
  text-align: center;
}
.actions li {
  display: inline-block;
  margin: 0.3em 0.3em;
  white-space: nowrap;
  a {
    white-space: nowrap;
  }
}
.actions-button {
  padding: 0.73em 1.47em;
  display: block;
  color: #35495e;
  cursor: pointer;
}

.logo {
  display: block;
  width: 230px;
  height: 70px;
  background-image: url(../assets/logo.png);
  background-repeat: no-repeat;
  background-size: 100%;
  position: relative;
}
</style>
